/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
export interface Action<T = string, P = unknown> {
    type: T
    payload?: P
    error?: any
    meta?: any

    [key: string]: any
}

export function createAction<T, P>(
    type: T,
    payload: P,
    error = false,
    meta = null
): Action<T, P> {
    return {
        type,
        payload,
        error,
        meta,
    }
}
